'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_magnolia1$002e$002dCall$002dBy$002dNeed from "./magnolia1.-Call-By-Need.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_CallByNeed$() {
}
export { $c_Lmagnolia1_CallByNeed$ as $c_Lmagnolia1_CallByNeed$ };
$p = $c_Lmagnolia1_CallByNeed$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_CallByNeed$;
/** @constructor */
function $h_Lmagnolia1_CallByNeed$() {
}
export { $h_Lmagnolia1_CallByNeed$ as $h_Lmagnolia1_CallByNeed$ };
$h_Lmagnolia1_CallByNeed$.prototype = $p;
$p.Z = (function(a) {
  return new $j_magnolia1$002e$002dCall$002dBy$002dNeed.$c_Lmagnolia1_CallByNeed(a, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => false)));
});
$p.a1 = (function(a) {
  return new $j_magnolia1$002e$002dCall$002dBy$002dNeed.$c_Lmagnolia1_CallByNeed(a, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => true)));
});
var $d_Lmagnolia1_CallByNeed$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_CallByNeed$, "magnolia1.CallByNeed$", ({
  nL: 1
}));
export { $d_Lmagnolia1_CallByNeed$ as $d_Lmagnolia1_CallByNeed$ };
var $n_Lmagnolia1_CallByNeed$;
function $m_Lmagnolia1_CallByNeed$() {
  if ((!$n_Lmagnolia1_CallByNeed$)) {
    $n_Lmagnolia1_CallByNeed$ = new $c_Lmagnolia1_CallByNeed$();
  }
  return $n_Lmagnolia1_CallByNeed$;
}
export { $m_Lmagnolia1_CallByNeed$ as $m_Lmagnolia1_CallByNeed$ };
